export const NAME = 'experimentation';
export const SET_FEATURES = `${NAME}/SET_FEATURES`;
export const SET_IS_AUTHENTICATED_FEATURES_LOADED = `${NAME}/SET_IS_AUTHENTICATED_FEATURES_LOADED`;
